"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCancelable = void 0;
var makeCancelable = function (promise) {
    var hasCanceled = false;
    var wrappedPromise = new Promise(function (resolve, reject) {
        promise.then(function (val) { return (hasCanceled ? reject({ isCanceled: true }) : resolve(val)); }, function (error) { return (hasCanceled ? reject({ isCanceled: true }) : reject(error)); });
    });
    return {
        promise: wrappedPromise,
        cancel: function () {
            hasCanceled = true;
        },
    };
};
exports.makeCancelable = makeCancelable;
//# sourceMappingURL=make-cancelable-promise.js.map